export const AlertsType = {
  // auth
  ISATKO001: 'AlertsTypeConstant/ISATKO001',
  ISATKO002: 'AlertsTypeConstant/ISATKO002',
  ISATKO003: 'AlertsTypeConstant/ISATKO003',
  ISATKO004: 'AlertsTypeConstant/ISATKO004',
  ISATKO005: 'AlertsTypeConstant/ISATKO005',
  ISATKO006: 'AlertsTypeConstant/ISATKO006',
  ISATKO007: 'AlertsTypeConstant/ISATKO007',
  ISATKO008: 'AlertsTypeConstant/ISATKO008',
  ISATKO009: 'AlertsTypeConstant/ISATKO009',
  ISATKO010: 'AlertsTypeConstant/ISATKO010',
  ISATKO011: 'AlertsTypeConstant/ISATKO011',
  ISATKO012: 'AlertsTypeConstant/ISATKO012',
  ISATKO013: 'AlertsTypeConstant/ISATKO013',
  ISATKO014: 'AlertsTypeConstant/ISATKO014',
  ISATKO015: 'AlertsTypeConstant/ISATKO015',
  ISATKO016: 'AlertsTypeConstant/ISATKO016',
  ISATKO017: 'AlertsTypeConstant/ISATKO017',

  // profile
  ISPFKO001: 'AlertsTypeConstant/ISPFKO001',
  ISPFKO002: 'AlertsTypeConstant/ISPFKO002',
  ISPFKO003: 'AlertsTypeConstant/ISPFKO003',
  ISPFKO004: 'AlertsTypeConstant/ISPFKO004',
  ISPFKO005: 'AlertsTypeConstant/ISPFKO005',
  ISPFKO006: 'AlertsTypeConstant/ISPFKO006',
  ISPFKO007: 'AlertsTypeConstant/ISPFKO007',
  ISPFKO008: 'AlertsTypeConstant/ISPFKO008',
  ISPFKO009: 'AlertsTypeConstant/ISPFKO009',
  ISPFKO010: 'AlertsTypeConstant/ISPFKO010',
  ISPFKO011: 'AlertsTypeConstant/ISPFKO011',
  ISPFKO012: 'AlertsTypeConstant/ISPFKO012',
  ISPFKO013: 'AlertsTypeConstant/ISPFKO013',

  // subscription
  ISSBKO001: 'AlertsTypeConstant/ISSBKO001',
  ISSBKO002: 'AlertsTypeConstant/ISSBKO002',

  // payment
  ISPMKO001: 'AlertsTypeConstant/ISPMKO001',
  ISPMKO002: 'AlertsTypeConstant/ISPMKO002',
  ISPMKO003: 'AlertsTypeConstant/ISPMKO003',
  ISPMKO004: 'AlertsTypeConstant/ISPMKO004',

  // knowledge base
  ISKBKO001: 'AlertsTypeConstant/ISKBKO001',
  ISKBKO002: 'AlertsTypeConstant/ISKBKO002',
  ISKBKO003: 'AlertsTypeConstant/ISKBKO003',
  ISKBKO004: 'AlertsTypeConstant/ISKBKO004',
  ISKBKO005: 'AlertsTypeConstant/ISKBKO005',
  ISKBKO006: 'AlertsTypeConstant/ISKBKO006',
  ISKBKO007: 'AlertsTypeConstant/ISKBKO007',
  ISKBKO008: 'AlertsTypeConstant/ISKBKO008',
  ISKBKO009: 'AlertsTypeConstant/ISKBKO009',
  ISKBKO010: 'AlertsTypeConstant/ISKBKO010',
  ISKBKO011: 'AlertsTypeConstant/ISKBKO011',
  ISKBKO012: 'AlertsTypeConstant/ISKBKO012',
  ISKBKO013: 'AlertsTypeConstant/ISKBKO013',
  ISKBKO014: 'AlertsTypeConstant/ISKBKO014',
  ISKBKO015: 'AlertsTypeConstant/ISKBKO015',
  ISKBKO016: 'AlertsTypeConstant/ISKBKO016',
  ISKBKO017: 'AlertsTypeConstant/ISKBKO017',
  ISKBKO018: 'AlertsTypeConstant/ISKBKO018',
  ISKBKO019: 'AlertsTypeConstant/ISKBKO019',
  ISKBKO020: 'AlertsTypeConstant/ISKBKO020',
  ISKBKO021: 'AlertsTypeConstant/ISKBKO021',
  ISKBKO022: 'AlertsTypeConstant/ISKBKO022',
  ISKBKO023: 'AlertsTypeConstant/ISKBKO023',
  ISKBKO024: 'AlertsTypeConstant/ISKBKO024',
  ISKBKO025: 'AlertsTypeConstant/ISKBKO025',
  ISKBKO026: 'AlertsTypeConstant/ISKBKO026',
  ISKBKO027: 'AlertsTypeConstant/ISKBKO027',

  // contact us
  ISCUKO001: 'AlertsTypeConstant/ISCUKO001',
  ISCUKO002: 'AlertsTypeConstant/ISCUKO002',
  ISCUKO003: 'AlertsTypeConstant/ISCUKO003',
  ISCUKO004: 'AlertsTypeConstant/ISCUKO004',

  // setting
  ISSTKO001: 'AlertsTypeConstant/ISSTKO001',
  ISSTKO002: 'AlertsTypeConstant/ISSTKO002',
  ISSTKO003: 'AlertsTypeConstant/ISSTKO003',
  ISSTKO004: 'AlertsTypeConstant/ISSTKO004',
  ISSTKO005: 'AlertsTypeConstant/ISSTKO005',
  ISSTKO006: 'AlertsTypeConstant/ISSTKO006',
  ISSTKO007: 'AlertsTypeConstant/ISSTKO007',
  ISSTKO008: 'AlertsTypeConstant/ISSTKO008',
  ISSTKO009: 'AlertsTypeConstant/ISSTKO009',

  // script
  ISSCKO001: 'AlertsTypeConstant/ISSCKO001',
  ISSCKO002: 'AlertsTypeConstant/ISSCKO002',

  // widget
  ISWGKO001: 'AlertsTypeConstant/ISWGKO001',
  ISWGKO002: 'AlertsTypeConstant/ISWGKO002',
  ISWGKO003: 'AlertsTypeConstant/ISWGKO003',
  ISWGKO004: 'AlertsTypeConstant/ISWGKO004',

  // global
  ISGLOK001: 'AlertsTypeConstant/ISGLOK001',
  ISGLOK002: 'AlertsTypeConstant/ISGLOK002',
};
